export default __webpack_public_path__ + "static/media/P348_RoHS.21e1b62b.pdf";